import {Component, Input, OnInit} from '@angular/core';
import {AdminService} from "../../../../../core/services/AdminService";
import {Events} from "../../../../../framework/providers/events";

@Component({
    selector: 'app-admin-footer',
    templateUrl: './admin-footer.component.html',
    styleUrls: ['./admin-footer.component.scss'],
})
export class AdminFooterComponent implements OnInit {

    @Input()
    sectionName;
    @Input()
    exTableData;
    @Input()
    model;

    constructor(public adminService: AdminService, public events: Events) {
    }

    ngOnInit() {
        this.events.subscribe('rowClick', data => {
            this.sectionName = data['sectionName'];
            this.exTableData = data['exTableData'];
            this.model = data['model'];
        });
    }

}
